/* eslint-disable no-magic-numbers */

import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_LETTER_RISE_IN = 'letterRiseIn';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const letterRiseInPresetDetails = {
  // The name of the preset.
  name: PRESET_LETTER_RISE_IN,

  // A human friendly name for the preset.
  humanName: 'Letter - Rise In',

  // The element names that this preset can be used for or true for all elements.
  elements: ['text'],

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'in',

  // Each property that will change during the transition.
  details: {
    'letter.translateY': {
      // The name of the easing this property will use.
      easing: EASINGS.easeOutExpo,

      // The start and end times for the transition of this property.
      time: {
        start: 'start.0',
        end: 'start.2000',
      },

      // The value of the property that will change during the transition.
      values: [30, 0],

      // Whether or not to stagger the transition for each letter or the stagger delay in milliseconds.
      stagger: 50,

      // The amount of time in milliseconds that each letter will animate, or false to auto-calculate.
      staggerDuration: false,
    },
    'letter.opacity': {
      // The name of the easing this property will use.
      easing: EASINGS.easeOutExpo,

      // The start and end times for the transition of this property.
      time: {
        start: 'start.0',
        end: 'start.2000',
      },

      // The value of the property that will change during the transition.
      values: [0, 1],

      // Whether or not to stagger the transition for each letter or the stagger delay in milliseconds.
      stagger: 50,

      // The amount of time in milliseconds that each letter will animate, or false to auto-calculate.
      staggerDuration: false,
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_LETTER_RISE_IN,
    options: {},
  },
};

letterRiseInPresetDetails.template.options = lodash.cloneDeep(letterRiseInPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_LETTER_RISE_IN;

// This defines the value of the presets object.
export default letterRiseInPresetDetails;
